import { CONSTRUCTION_TYPE_ICON_GROUPS } from 'assets/constructionTypeIcons';
import type { IConstructionTypeIconGroup } from 'assets/constructionTypeIcons';
import { ModalDialog } from 'components/ModalDialog';
import { Tabs } from 'uikit';

import cn from 'classnames';
import { useState } from 'react';

import Styles from './selectConstructionTypeIconModal.module.css';

interface ISelectConstructionTypeIconModal {
    isOpen: boolean;
    onClose: () => void;
    onSave: (iconCode: string) => void;
}

export const SelectConstructionTypeIconModal = ({ isOpen, onClose, onSave }: ISelectConstructionTypeIconModal) => {
    const [activeGroup, setActiveGroup] = useState<IConstructionTypeIconGroup>(CONSTRUCTION_TYPE_ICON_GROUPS[0]);
    const [selectedIconCode, setSelectedIconCode] = useState<string | null>(null);

    const handleTabChange = ({ value }: { value: IConstructionTypeIconGroup }) => {
        setActiveGroup(value);
        setSelectedIconCode(null);
    };

    const handleSave = () => {
        if (selectedIconCode) {
            onSave(selectedIconCode);
        }
    };

    return (
        <ModalDialog
            isOpen={isOpen}
            title="Выбор иконки"
            onClose={onClose}
            onConfirm={handleSave}
            btnConfirmLabel="Сохранить"
            btnConfirmDisabled={!selectedIconCode}
            withTitleCloseButton
            isOnClickOutsideDisable
            style={{ width: '620px' }}
        >
            <div className={Styles.content}>
                <Tabs
                    items={CONSTRUCTION_TYPE_ICON_GROUPS}
                    value={activeGroup}
                    onChange={handleTabChange}
                    getItemLabel={(group: IConstructionTypeIconGroup) => group.label}
                    size="s"
                />
                <div className={Styles.iconsGrid}>
                    {activeGroup.icons.map(({ code, src }) => (
                        <button
                            key={code}
                            type="button"
                            className={cn(Styles.iconButton, {
                                [Styles.iconButtonSelected]: code === selectedIconCode,
                            })}
                            onClick={() => setSelectedIconCode(code)}
                            aria-pressed={code === selectedIconCode}
                        >
                            <img src={src} alt="" className={Styles.icon} />
                        </button>
                    ))}
                </div>
            </div>
        </ModalDialog>
    );
};

SelectConstructionTypeIconModal.displayName = 'SelectConstructionTypeIconModal';
